import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getInventoryGeneralInquiryItemDetails, getInventoryGeneralInquiryNoOfLocation } from "./service/inventoryOverview.service";
import { GeneralInquiryPayload, InventoryGeneralInquiryItemDetails, InventoryGeneralInquiryNoOfLocation, InventoryDetailsTabProps } from "./model/inventoryOverview.model";
import Loader from "../../../Components/GlobalLoader/Loader";
import Table, { Column } from "../../../Components/Tables/Table";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";
import { usePagination } from "../../../hooks/usePagination";

export const GeneralInquiry: React.FC<InventoryDetailsTabProps> = ({
    warehouseId
}) => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [itemDetailsData, setItemDetailsData] = useState<InventoryGeneralInquiryItemDetails>();
  const [noOfLocation, setNoOfLocation] = useState<InventoryGeneralInquiryNoOfLocation[]>([]);
  const [recordsTotal, setRecordsTotal] = useState<number>(0);
  const { currentPage, handlePageChange, perPage } = usePagination();
  let payload = { ...GeneralInquiryPayload };
  const shiptocolumns: Column[] = [
    {
      name: "Locations",
      selector: (row: InventoryGeneralInquiryNoOfLocation) => row?.name ? row?.name : '-',
    },
    {
      name: "Qty",
      selector: (row: InventoryGeneralInquiryNoOfLocation) => row?.qty_on_hand ? row?.qty_on_hand : 0,
    },
    {
      name: "Tag",
      selector: (row: InventoryGeneralInquiryNoOfLocation) => row?.total_distinct_tags ? row?.total_distinct_tags : '-',
    },
    {
      name: "Serial",
      selector: (row: InventoryGeneralInquiryNoOfLocation) => row?.total_distinct_serials ? row?.total_distinct_serials : 0,
    }
  ];

  useEffect(() => {
    if (id) {
      setLoading(true);
      payload.conditions = [
        ["item.id", "=", id],
        ["warehouse.id", "=", warehouseId]
      ];
      payload.group = [
        "warehouse_location.name"
      ];
      payload.limit = perPage;
      payload.page = currentPage;
      const param = "with_qtys=true";
      getInventoryGeneralInquiryItemDetails(id, param).then((response) => {
        setItemDetailsData(response.data);
      }).then(()=>{
        getInventoryGeneralInquiryNoOfLocation(payload).then((response) => {
          setNoOfLocation(response.data.results);
          setRecordsTotal(response.data.recordsTotal);
          setLoading(false);
        })
      })
    }
  }, [id, currentPage,warehouseId]);

  const columns = [
    { label: "Item Name", value: itemDetailsData?.name },
    { label: "Qty On Hand", value: itemDetailsData?.qty_on_hand ? itemDetailsData?.qty_on_hand : 0 },
    { label: "Available To Ship", value: itemDetailsData?.qty_available ? itemDetailsData?.qty_available : 0 },
    { label: "Reserved Qty", value: itemDetailsData?.qty_reserved ? itemDetailsData?.qty_reserved : 0 },
    { label: "Expected Qty", value: itemDetailsData?.qty_expected ? itemDetailsData?.qty_expected : 0 },
    { label: "Min Stock Level", value: itemDetailsData?.min_stock_level ? itemDetailsData?.min_stock_level : 0 },
    { label: "Max Stock Level", value: itemDetailsData?.max_stock_level ? itemDetailsData?.max_stock_level : 0 },
    { label: "Item Group", value: itemDetailsData?.item_group },
  ]

  return !loading ? (
    <>
      <DynamicDetailGrid customClassName="my-2" isExpandable={false} columns={3} data={columns} />
      <h6 className="text-start mb-2">No of location({recordsTotal})</h6>
      <div className="mb-2 mt-1 bg-white rounded px-4 py-3">
        <Table
          columns={shiptocolumns}
          data={noOfLocation ?? []}
          CheckboxStatus={false}
          isStripped={true}
          customClassName="transferDetailsTable"
          pagination={{
            recordsPerPage: perPage,
            totalRecords: recordsTotal,
            currentPage: currentPage,
            onCurrentPageChange: handlePageChange,
          }}
        />
      </div>
    </>
  ) : <Loader />;
}
